import { api } from './api';
import type { Profile } from '../types';

export const profilesApi = {
  list: () => api.get<Profile[]>('/profiles'),
  create: (data: { name: string; niche?: string; language?: string }) =>
    api.post<{ id: number; name: string }>('/profiles', data),
  update: (id: number, data: Partial<Profile>) =>
    api.patch(`/profiles/${id}`, data),
  aiSparring: (prompt: string, niche?: string) =>
    api.post<{ response: string }>('/profiles/ai-sparring', { prompt, niche }),
};
